import { render, staticRenderFns } from "./AccountSection.vue?vue&type=template&id=4324f496"
import script from "./AccountSection.vue?vue&type=script&lang=js"
export * from "./AccountSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports